import { Lock } from 'lucide-react';

interface UpgradePromptProps {
  message: string;
  inline?: boolean;
}

export function UpgradePrompt({ message, inline }: UpgradePromptProps) {
  if (inline) {
    return (
      <span className="upgrade-prompt-inline">
        <Lock size={12} aria-hidden="true" />
        {message}
      </span>
    );
  }

  return (
    <div className="upgrade-prompt">
      <Lock size={16} aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
